document.addEventListener('DOMContentLoaded', function() {
  const apoiosDiv = document.querySelector('.div-apoios');
  const footer = document.getElementById('main-footer');


  if (!apoiosDiv || !footer) return;
  const corOpaca = 'rgba(128, 128, 128, 1)';
  const corTransparente = 'rgba(128, 128, 128, 0.4)';

  // ... dentro da função checkFooterProximity
  function checkFooterProximity() {
    const scrollPosition = window.scrollY;
    const documentHeight = document.body.scrollHeight;
    const viewportHeight = window.innerHeight;

    // Calcula a posição do topo do footer (posição total do scroll)
    const footerTop = footer.offsetTop;

    // Define a zona de transição (ex: nos últimos 300px do scroll)
    const transitionZoneHeight = 300;
    const transitionStart = footerTop - viewportHeight - transitionZoneHeight;

    if (scrollPosition < transitionStart) {
      // 1. Está longe do footer: Transparência Máxima (0.4)
      apoiosDiv.style.backgroundColor = corTransparente;
    } else if (scrollPosition >= footerTop - viewportHeight) {
      // 2. Footer já entrou no ecrã: Opacidade Máxima (1.0)
      apoiosDiv.style.backgroundColor = corOpaca;
    } else {
      // 3. Está na zona de transição: Calcula a opacidade

      // Posição atual dentro da zona de transição (0 a transitionZoneHeight)
      const positionInZone = scrollPosition - transitionStart;

      // Calcula a percentagem de progresso na transição (0 a 1)
      const progress = positionInZone / transitionZoneHeight;

      // Opacidade inicial é 0.4, opacidade final é 1.0. A diferença é 0.6.
      const startAlpha = 0.4;
      const endAlpha = 1.0;
      const alphaRange = endAlpha - startAlpha;

      // Novo valor alpha (entre 0.4 e 1.0)
      const newAlpha = startAlpha + (progress * alphaRange);

      // Aplica a nova cor de fundo com opacidade gradual
      // Nota: 128 é o valor RGB para 80 (cinzento)
      apoiosDiv.style.backgroundColor = `rgba(128, 128, 128, ${newAlpha.toFixed(2)})`;
    }
  }

  // Executa a função na primeira carga e sempre que a página for rolada
  window.addEventListener('scroll', checkFooterProximity);
  window.addEventListener('resize', checkFooterProximity); // Para ajustar ao redimensionar
  checkFooterProximity(); // Executa uma vez no carregamento
});
